import { Button } from '@upheal/design-system/components/Button/Button';
import { Typography } from '@upheal/design-system/components/Typography/Typography';
import { useSnackbar } from '@upheal/design-system/vendor/notistack';
import { uiEventDataAttrs } from '@upheal/shared/utils/analytics/ui-tracking';
import { usePermissions } from '@upheal/shared/state/usePermissions';
import { useCheckout } from '../../hooks/useCheckout';
import { PricingTier } from '../../utils/plans';

import { SxProps, Theme } from '@mui/material';

type ActivatePlanButtonProps = {
    uiLocation: string;
    uiProperty?: string;
    sx?: SxProps<Theme>;
};

export const ActivatePlanButton = ({
    uiLocation,
    uiProperty,
    sx,
}: ActivatePlanButtonProps) => {
    const { createCheckoutSession, loading } = useCheckout();
    const { enqueueSnackbar } = useSnackbar();
    const { canPurchasePlan } = usePermissions();

    const handleActivate = async () => {
        if (!canPurchasePlan) {
            enqueueSnackbar(
                'Please contact your administrator to choose a plan that includes this feature.',
                { variant: 'info' },
            );
            return;
        }

        const checkoutUrl = await createCheckoutSession(PricingTier.METERED);

        if (checkoutUrl) {
            window.open(checkoutUrl, '_self', 'noopener,noreferrer');
        }
    };

    return (
        <Button
            variant="solid"
            colorScheme="accent1"
            size="md"
            sx={sx}
            onClick={handleActivate}
            loading={loading}
            {...uiEventDataAttrs(
                'Activate Premium Plan',
                uiLocation,
                uiProperty,
            )}
        >
            <Typography slot="label">Subscribe to Premium</Typography>
        </Button>
    );
};
